/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as DistributorRouteImport } from './routes/distributor'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DistributorIndexRouteImport } from './routes/distributor.index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CreateIndexRouteImport } from './routes/create.index'
import { Route as UuidIndexRouteImport } from './routes/$uuid.index'
import { Route as HSlugRouteImport } from './routes/h.$slug'
import { Route as DashboardVoiceSalesRouteImport } from './routes/dashboard/voice-sales'
import { Route as DashboardBulkJobsRouteImport } from './routes/dashboard/bulk-jobs'
import { Route as DPathRouteImport } from './routes/d.$path'
import { Route as CreatePublicCodeRouteImport } from './routes/create.$publicCode'
import { Route as ChainSlugOrUuidRouteImport } from './routes/chain.$slugOrUuid'
import { Route as CAdamRouteImport } from './routes/c.adam'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as DashboardZipBlastsIndexRouteImport } from './routes/dashboard/zip-blasts.index'
import { Route as DashboardVoiceSalesIndexRouteImport } from './routes/dashboard/voice-sales.index'
import { Route as DashboardScorecardIndexRouteImport } from './routes/dashboard/scorecard.index'
import { Route as DashboardPlacesIndexRouteImport } from './routes/dashboard/places.index'
import { Route as DashboardListsIndexRouteImport } from './routes/dashboard/lists.index'
import { Route as DashboardDistributorsIndexRouteImport } from './routes/dashboard/distributors.index'
import { Route as DashboardContactsIndexRouteImport } from './routes/dashboard/contacts.index'
import { Route as DashboardChainsIndexRouteImport } from './routes/dashboard/chains.index'
import { Route as ConsentSmsIndexRouteImport } from './routes/consent.sms.index'
import { Route as DashboardZipBlastsNewRouteImport } from './routes/dashboard/zip-blasts_.new'
import { Route as DashboardZipBlastsUuidRouteImport } from './routes/dashboard/zip-blasts_.$uuid'
import { Route as DashboardVoiceSalesCampaignsRouteImport } from './routes/dashboard/voice-sales.campaigns'
import { Route as DashboardVoiceSalesCallsRouteImport } from './routes/dashboard/voice-sales.calls'
import { Route as DashboardVoiceSalesAgentRouteImport } from './routes/dashboard/voice-sales.agent'
import { Route as DashboardScorecardCreateRouteImport } from './routes/dashboard/scorecard_.create'
import { Route as DashboardScorecardWatchlistRouteImport } from './routes/dashboard/scorecard.watchlist'
import { Route as DashboardScorecardThresholdsRouteImport } from './routes/dashboard/scorecard.thresholds'
import { Route as DashboardScorecardMonitorRouteImport } from './routes/dashboard/scorecard.monitor'
import { Route as DashboardPlacesUuidRouteImport } from './routes/dashboard/places_.$uuid'
import { Route as DashboardListsUuidRouteImport } from './routes/dashboard/lists_.$uuid'
import { Route as DashboardDripEmailsRouteImport } from './routes/dashboard/drip.emails'
import { Route as DashboardDripDashboardRouteImport } from './routes/dashboard/drip.dashboard'
import { Route as DashboardDistributorsUuidRouteImport } from './routes/dashboard/distributors_.$uuid'
import { Route as DashboardContactsUuidRouteImport } from './routes/dashboard/contacts_.$uuid'
import { Route as ConsentSmsDetailsRouteImport } from './routes/consent.sms.details'
import { Route as DashboardScorecardChainsIndexRouteImport } from './routes/dashboard/scorecard.chains.index'
import { Route as DashboardDripContactsIndexRouteImport } from './routes/dashboard/drip.contacts.index'
import { Route as DashboardDripCampaignsIndexRouteImport } from './routes/dashboard/drip.campaigns.index'
import { Route as DashboardChainsChainUuidIndexRouteImport } from './routes/dashboard/chains_.$chainUuid.index'
import { Route as DripEmailsUuidReportRouteImport } from './routes/drip.emails.$uuid.report'
import { Route as DripContactsUuidOptOutRouteImport } from './routes/drip.contacts.$uuid.opt-out'
import { Route as DashboardVoiceSalesCampaignsNewRouteImport } from './routes/dashboard/voice-sales.campaigns_.new'
import { Route as DashboardVoiceSalesCampaignsCampaignUuidRouteImport } from './routes/dashboard/voice-sales.campaigns_.$campaignUuid'
import { Route as DashboardVoiceSalesCallsCallUuidRouteImport } from './routes/dashboard/voice-sales.calls_.$callUuid'
import { Route as DashboardScorecardWatchlistUuidRouteImport } from './routes/dashboard/scorecard.watchlist_.$uuid'
import { Route as DashboardScorecardChainsUuidRouteImport } from './routes/dashboard/scorecard.chains_.$uuid'
import { Route as DashboardDripContactsUuidRouteImport } from './routes/dashboard/drip.contacts_.$uuid'
import { Route as DashboardDripCampaignsUuidRouteImport } from './routes/dashboard/drip.campaigns_.$uuid'
import { Route as DashboardChainsSearchesUuidRouteImport } from './routes/dashboard/chains_.searches.$uuid'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorRoute = DistributorRouteImport.update({
  id: '/distributor',
  path: '/distributor',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorIndexRoute = DistributorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DistributorRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const CreateIndexRoute = CreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRouteImport,
} as any)
const UuidIndexRoute = UuidIndexRouteImport.update({
  id: '/$uuid/',
  path: '/$uuid/',
  getParentRoute: () => rootRouteImport,
} as any)
const HSlugRoute = HSlugRouteImport.update({
  id: '/h/$slug',
  path: '/h/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardVoiceSalesRoute = DashboardVoiceSalesRouteImport.update({
  id: '/voice-sales',
  path: '/voice-sales',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardBulkJobsRoute = DashboardBulkJobsRouteImport.update({
  id: '/bulk-jobs',
  path: '/bulk-jobs',
  getParentRoute: () => DashboardRoute,
} as any)
const DPathRoute = DPathRouteImport.update({
  id: '/d/$path',
  path: '/d/$path',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatePublicCodeRoute = CreatePublicCodeRouteImport.update({
  id: '/create/$publicCode',
  path: '/create/$publicCode',
  getParentRoute: () => rootRouteImport,
} as any)
const ChainSlugOrUuidRoute = ChainSlugOrUuidRouteImport.update({
  id: '/chain/$slugOrUuid',
  path: '/chain/$slugOrUuid',
  getParentRoute: () => rootRouteImport,
} as any)
const CAdamRoute = CAdamRouteImport.update({
  id: '/c/adam',
  path: '/c/adam',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardZipBlastsIndexRoute = DashboardZipBlastsIndexRouteImport.update({
  id: '/zip-blasts/',
  path: '/zip-blasts/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardVoiceSalesIndexRoute =
  DashboardVoiceSalesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardScorecardIndexRoute = DashboardScorecardIndexRouteImport.update({
  id: '/scorecard/',
  path: '/scorecard/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPlacesIndexRoute = DashboardPlacesIndexRouteImport.update({
  id: '/places/',
  path: '/places/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardListsIndexRoute = DashboardListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDistributorsIndexRoute =
  DashboardDistributorsIndexRouteImport.update({
    id: '/distributors/',
    path: '/distributors/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContactsIndexRoute = DashboardContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardChainsIndexRoute = DashboardChainsIndexRouteImport.update({
  id: '/chains/',
  path: '/chains/',
  getParentRoute: () => DashboardRoute,
} as any)
const ConsentSmsIndexRoute = ConsentSmsIndexRouteImport.update({
  id: '/consent/sms/',
  path: '/consent/sms/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardZipBlastsNewRoute = DashboardZipBlastsNewRouteImport.update({
  id: '/zip-blasts_/new',
  path: '/zip-blasts/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardZipBlastsUuidRoute = DashboardZipBlastsUuidRouteImport.update({
  id: '/zip-blasts_/$uuid',
  path: '/zip-blasts/$uuid',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardVoiceSalesCampaignsRoute =
  DashboardVoiceSalesCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardVoiceSalesCallsRoute =
  DashboardVoiceSalesCallsRouteImport.update({
    id: '/calls',
    path: '/calls',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardVoiceSalesAgentRoute =
  DashboardVoiceSalesAgentRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardScorecardCreateRoute =
  DashboardScorecardCreateRouteImport.update({
    id: '/scorecard_/create',
    path: '/scorecard/create',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardScorecardWatchlistRoute =
  DashboardScorecardWatchlistRouteImport.update({
    id: '/scorecard/watchlist',
    path: '/scorecard/watchlist',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardScorecardThresholdsRoute =
  DashboardScorecardThresholdsRouteImport.update({
    id: '/scorecard/thresholds',
    path: '/scorecard/thresholds',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardScorecardMonitorRoute =
  DashboardScorecardMonitorRouteImport.update({
    id: '/scorecard/monitor',
    path: '/scorecard/monitor',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPlacesUuidRoute = DashboardPlacesUuidRouteImport.update({
  id: '/places_/$uuid',
  path: '/places/$uuid',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardListsUuidRoute = DashboardListsUuidRouteImport.update({
  id: '/lists_/$uuid',
  path: '/lists/$uuid',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDripEmailsRoute = DashboardDripEmailsRouteImport.update({
  id: '/drip/emails',
  path: '/drip/emails',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDripDashboardRoute = DashboardDripDashboardRouteImport.update({
  id: '/drip/dashboard',
  path: '/drip/dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDistributorsUuidRoute =
  DashboardDistributorsUuidRouteImport.update({
    id: '/distributors_/$uuid',
    path: '/distributors/$uuid',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardContactsUuidRoute = DashboardContactsUuidRouteImport.update({
  id: '/contacts_/$uuid',
  path: '/contacts/$uuid',
  getParentRoute: () => DashboardRoute,
} as any)
const ConsentSmsDetailsRoute = ConsentSmsDetailsRouteImport.update({
  id: '/consent/sms/details',
  path: '/consent/sms/details',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardScorecardChainsIndexRoute =
  DashboardScorecardChainsIndexRouteImport.update({
    id: '/scorecard/chains/',
    path: '/scorecard/chains/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDripContactsIndexRoute =
  DashboardDripContactsIndexRouteImport.update({
    id: '/drip/contacts/',
    path: '/drip/contacts/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDripCampaignsIndexRoute =
  DashboardDripCampaignsIndexRouteImport.update({
    id: '/drip/campaigns/',
    path: '/drip/campaigns/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardChainsChainUuidIndexRoute =
  DashboardChainsChainUuidIndexRouteImport.update({
    id: '/chains_/$chainUuid/',
    path: '/chains/$chainUuid/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DripEmailsUuidReportRoute = DripEmailsUuidReportRouteImport.update({
  id: '/drip/emails/$uuid/report',
  path: '/drip/emails/$uuid/report',
  getParentRoute: () => rootRouteImport,
} as any)
const DripContactsUuidOptOutRoute = DripContactsUuidOptOutRouteImport.update({
  id: '/drip/contacts/$uuid/opt-out',
  path: '/drip/contacts/$uuid/opt-out',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardVoiceSalesCampaignsNewRoute =
  DashboardVoiceSalesCampaignsNewRouteImport.update({
    id: '/campaigns_/new',
    path: '/campaigns/new',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardVoiceSalesCampaignsCampaignUuidRoute =
  DashboardVoiceSalesCampaignsCampaignUuidRouteImport.update({
    id: '/campaigns_/$campaignUuid',
    path: '/campaigns/$campaignUuid',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardVoiceSalesCallsCallUuidRoute =
  DashboardVoiceSalesCallsCallUuidRouteImport.update({
    id: '/calls_/$callUuid',
    path: '/calls/$callUuid',
    getParentRoute: () => DashboardVoiceSalesRoute,
  } as any)
const DashboardScorecardWatchlistUuidRoute =
  DashboardScorecardWatchlistUuidRouteImport.update({
    id: '/scorecard/watchlist_/$uuid',
    path: '/scorecard/watchlist/$uuid',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardScorecardChainsUuidRoute =
  DashboardScorecardChainsUuidRouteImport.update({
    id: '/scorecard/chains_/$uuid',
    path: '/scorecard/chains/$uuid',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDripContactsUuidRoute =
  DashboardDripContactsUuidRouteImport.update({
    id: '/drip/contacts_/$uuid',
    path: '/drip/contacts/$uuid',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardDripCampaignsUuidRoute =
  DashboardDripCampaignsUuidRouteImport.update({
    id: '/drip/campaigns_/$uuid',
    path: '/drip/campaigns/$uuid',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardChainsSearchesUuidRoute =
  DashboardChainsSearchesUuidRouteImport.update({
    id: '/chains_/searches/$uuid',
    path: '/chains/searches/$uuid',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/distributor': typeof DistributorRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/c/adam': typeof CAdamRoute
  '/chain/$slugOrUuid': typeof ChainSlugOrUuidRoute
  '/create/$publicCode': typeof CreatePublicCodeRoute
  '/d/$path': typeof DPathRoute
  '/dashboard/bulk-jobs': typeof DashboardBulkJobsRoute
  '/dashboard/voice-sales': typeof DashboardVoiceSalesRouteWithChildren
  '/h/$slug': typeof HSlugRoute
  '/$uuid/': typeof UuidIndexRoute
  '/create/': typeof CreateIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/distributor/': typeof DistributorIndexRoute
  '/consent/sms/details': typeof ConsentSmsDetailsRoute
  '/dashboard/contacts/$uuid': typeof DashboardContactsUuidRoute
  '/dashboard/distributors/$uuid': typeof DashboardDistributorsUuidRoute
  '/dashboard/drip/dashboard': typeof DashboardDripDashboardRoute
  '/dashboard/drip/emails': typeof DashboardDripEmailsRoute
  '/dashboard/lists/$uuid': typeof DashboardListsUuidRoute
  '/dashboard/places/$uuid': typeof DashboardPlacesUuidRoute
  '/dashboard/scorecard/monitor': typeof DashboardScorecardMonitorRoute
  '/dashboard/scorecard/thresholds': typeof DashboardScorecardThresholdsRoute
  '/dashboard/scorecard/watchlist': typeof DashboardScorecardWatchlistRoute
  '/dashboard/scorecard/create': typeof DashboardScorecardCreateRoute
  '/dashboard/voice-sales/agent': typeof DashboardVoiceSalesAgentRoute
  '/dashboard/voice-sales/calls': typeof DashboardVoiceSalesCallsRoute
  '/dashboard/voice-sales/campaigns': typeof DashboardVoiceSalesCampaignsRoute
  '/dashboard/zip-blasts/$uuid': typeof DashboardZipBlastsUuidRoute
  '/dashboard/zip-blasts/new': typeof DashboardZipBlastsNewRoute
  '/consent/sms/': typeof ConsentSmsIndexRoute
  '/dashboard/chains/': typeof DashboardChainsIndexRoute
  '/dashboard/contacts/': typeof DashboardContactsIndexRoute
  '/dashboard/distributors/': typeof DashboardDistributorsIndexRoute
  '/dashboard/lists/': typeof DashboardListsIndexRoute
  '/dashboard/places/': typeof DashboardPlacesIndexRoute
  '/dashboard/scorecard/': typeof DashboardScorecardIndexRoute
  '/dashboard/voice-sales/': typeof DashboardVoiceSalesIndexRoute
  '/dashboard/zip-blasts/': typeof DashboardZipBlastsIndexRoute
  '/dashboard/chains/searches/$uuid': typeof DashboardChainsSearchesUuidRoute
  '/dashboard/drip/campaigns/$uuid': typeof DashboardDripCampaignsUuidRoute
  '/dashboard/drip/contacts/$uuid': typeof DashboardDripContactsUuidRoute
  '/dashboard/scorecard/chains/$uuid': typeof DashboardScorecardChainsUuidRoute
  '/dashboard/scorecard/watchlist/$uuid': typeof DashboardScorecardWatchlistUuidRoute
  '/dashboard/voice-sales/calls/$callUuid': typeof DashboardVoiceSalesCallsCallUuidRoute
  '/dashboard/voice-sales/campaigns/$campaignUuid': typeof DashboardVoiceSalesCampaignsCampaignUuidRoute
  '/dashboard/voice-sales/campaigns/new': typeof DashboardVoiceSalesCampaignsNewRoute
  '/drip/contacts/$uuid/opt-out': typeof DripContactsUuidOptOutRoute
  '/drip/emails/$uuid/report': typeof DripEmailsUuidReportRoute
  '/dashboard/chains/$chainUuid/': typeof DashboardChainsChainUuidIndexRoute
  '/dashboard/drip/campaigns/': typeof DashboardDripCampaignsIndexRoute
  '/dashboard/drip/contacts/': typeof DashboardDripContactsIndexRoute
  '/dashboard/scorecard/chains/': typeof DashboardScorecardChainsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/c/adam': typeof CAdamRoute
  '/chain/$slugOrUuid': typeof ChainSlugOrUuidRoute
  '/create/$publicCode': typeof CreatePublicCodeRoute
  '/d/$path': typeof DPathRoute
  '/dashboard/bulk-jobs': typeof DashboardBulkJobsRoute
  '/h/$slug': typeof HSlugRoute
  '/$uuid': typeof UuidIndexRoute
  '/create': typeof CreateIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/distributor': typeof DistributorIndexRoute
  '/consent/sms/details': typeof ConsentSmsDetailsRoute
  '/dashboard/contacts/$uuid': typeof DashboardContactsUuidRoute
  '/dashboard/distributors/$uuid': typeof DashboardDistributorsUuidRoute
  '/dashboard/drip/dashboard': typeof DashboardDripDashboardRoute
  '/dashboard/drip/emails': typeof DashboardDripEmailsRoute
  '/dashboard/lists/$uuid': typeof DashboardListsUuidRoute
  '/dashboard/places/$uuid': typeof DashboardPlacesUuidRoute
  '/dashboard/scorecard/monitor': typeof DashboardScorecardMonitorRoute
  '/dashboard/scorecard/thresholds': typeof DashboardScorecardThresholdsRoute
  '/dashboard/scorecard/watchlist': typeof DashboardScorecardWatchlistRoute
  '/dashboard/scorecard/create': typeof DashboardScorecardCreateRoute
  '/dashboard/voice-sales/agent': typeof DashboardVoiceSalesAgentRoute
  '/dashboard/voice-sales/calls': typeof DashboardVoiceSalesCallsRoute
  '/dashboard/voice-sales/campaigns': typeof DashboardVoiceSalesCampaignsRoute
  '/dashboard/zip-blasts/$uuid': typeof DashboardZipBlastsUuidRoute
  '/dashboard/zip-blasts/new': typeof DashboardZipBlastsNewRoute
  '/consent/sms': typeof ConsentSmsIndexRoute
  '/dashboard/chains': typeof DashboardChainsIndexRoute
  '/dashboard/contacts': typeof DashboardContactsIndexRoute
  '/dashboard/distributors': typeof DashboardDistributorsIndexRoute
  '/dashboard/lists': typeof DashboardListsIndexRoute
  '/dashboard/places': typeof DashboardPlacesIndexRoute
  '/dashboard/scorecard': typeof DashboardScorecardIndexRoute
  '/dashboard/voice-sales': typeof DashboardVoiceSalesIndexRoute
  '/dashboard/zip-blasts': typeof DashboardZipBlastsIndexRoute
  '/dashboard/chains/searches/$uuid': typeof DashboardChainsSearchesUuidRoute
  '/dashboard/drip/campaigns/$uuid': typeof DashboardDripCampaignsUuidRoute
  '/dashboard/drip/contacts/$uuid': typeof DashboardDripContactsUuidRoute
  '/dashboard/scorecard/chains/$uuid': typeof DashboardScorecardChainsUuidRoute
  '/dashboard/scorecard/watchlist/$uuid': typeof DashboardScorecardWatchlistUuidRoute
  '/dashboard/voice-sales/calls/$callUuid': typeof DashboardVoiceSalesCallsCallUuidRoute
  '/dashboard/voice-sales/campaigns/$campaignUuid': typeof DashboardVoiceSalesCampaignsCampaignUuidRoute
  '/dashboard/voice-sales/campaigns/new': typeof DashboardVoiceSalesCampaignsNewRoute
  '/drip/contacts/$uuid/opt-out': typeof DripContactsUuidOptOutRoute
  '/drip/emails/$uuid/report': typeof DripEmailsUuidReportRoute
  '/dashboard/chains/$chainUuid': typeof DashboardChainsChainUuidIndexRoute
  '/dashboard/drip/campaigns': typeof DashboardDripCampaignsIndexRoute
  '/dashboard/drip/contacts': typeof DashboardDripContactsIndexRoute
  '/dashboard/scorecard/chains': typeof DashboardScorecardChainsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/distributor': typeof DistributorRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/c/adam': typeof CAdamRoute
  '/chain/$slugOrUuid': typeof ChainSlugOrUuidRoute
  '/create/$publicCode': typeof CreatePublicCodeRoute
  '/d/$path': typeof DPathRoute
  '/dashboard/bulk-jobs': typeof DashboardBulkJobsRoute
  '/dashboard/voice-sales': typeof DashboardVoiceSalesRouteWithChildren
  '/h/$slug': typeof HSlugRoute
  '/$uuid/': typeof UuidIndexRoute
  '/create/': typeof CreateIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/distributor/': typeof DistributorIndexRoute
  '/consent/sms/details': typeof ConsentSmsDetailsRoute
  '/dashboard/contacts_/$uuid': typeof DashboardContactsUuidRoute
  '/dashboard/distributors_/$uuid': typeof DashboardDistributorsUuidRoute
  '/dashboard/drip/dashboard': typeof DashboardDripDashboardRoute
  '/dashboard/drip/emails': typeof DashboardDripEmailsRoute
  '/dashboard/lists_/$uuid': typeof DashboardListsUuidRoute
  '/dashboard/places_/$uuid': typeof DashboardPlacesUuidRoute
  '/dashboard/scorecard/monitor': typeof DashboardScorecardMonitorRoute
  '/dashboard/scorecard/thresholds': typeof DashboardScorecardThresholdsRoute
  '/dashboard/scorecard/watchlist': typeof DashboardScorecardWatchlistRoute
  '/dashboard/scorecard_/create': typeof DashboardScorecardCreateRoute
  '/dashboard/voice-sales/agent': typeof DashboardVoiceSalesAgentRoute
  '/dashboard/voice-sales/calls': typeof DashboardVoiceSalesCallsRoute
  '/dashboard/voice-sales/campaigns': typeof DashboardVoiceSalesCampaignsRoute
  '/dashboard/zip-blasts_/$uuid': typeof DashboardZipBlastsUuidRoute
  '/dashboard/zip-blasts_/new': typeof DashboardZipBlastsNewRoute
  '/consent/sms/': typeof ConsentSmsIndexRoute
  '/dashboard/chains/': typeof DashboardChainsIndexRoute
  '/dashboard/contacts/': typeof DashboardContactsIndexRoute
  '/dashboard/distributors/': typeof DashboardDistributorsIndexRoute
  '/dashboard/lists/': typeof DashboardListsIndexRoute
  '/dashboard/places/': typeof DashboardPlacesIndexRoute
  '/dashboard/scorecard/': typeof DashboardScorecardIndexRoute
  '/dashboard/voice-sales/': typeof DashboardVoiceSalesIndexRoute
  '/dashboard/zip-blasts/': typeof DashboardZipBlastsIndexRoute
  '/dashboard/chains_/searches/$uuid': typeof DashboardChainsSearchesUuidRoute
  '/dashboard/drip/campaigns_/$uuid': typeof DashboardDripCampaignsUuidRoute
  '/dashboard/drip/contacts_/$uuid': typeof DashboardDripContactsUuidRoute
  '/dashboard/scorecard/chains_/$uuid': typeof DashboardScorecardChainsUuidRoute
  '/dashboard/scorecard/watchlist_/$uuid': typeof DashboardScorecardWatchlistUuidRoute
  '/dashboard/voice-sales/calls_/$callUuid': typeof DashboardVoiceSalesCallsCallUuidRoute
  '/dashboard/voice-sales/campaigns_/$campaignUuid': typeof DashboardVoiceSalesCampaignsCampaignUuidRoute
  '/dashboard/voice-sales/campaigns_/new': typeof DashboardVoiceSalesCampaignsNewRoute
  '/drip/contacts/$uuid/opt-out': typeof DripContactsUuidOptOutRoute
  '/drip/emails/$uuid/report': typeof DripEmailsUuidReportRoute
  '/dashboard/chains_/$chainUuid/': typeof DashboardChainsChainUuidIndexRoute
  '/dashboard/drip/campaigns/': typeof DashboardDripCampaignsIndexRoute
  '/dashboard/drip/contacts/': typeof DashboardDripContactsIndexRoute
  '/dashboard/scorecard/chains/': typeof DashboardScorecardChainsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/distributor'
    | '/privacy'
    | '/auth/callback'
    | '/c/adam'
    | '/chain/$slugOrUuid'
    | '/create/$publicCode'
    | '/d/$path'
    | '/dashboard/bulk-jobs'
    | '/dashboard/voice-sales'
    | '/h/$slug'
    | '/$uuid/'
    | '/create/'
    | '/dashboard/'
    | '/distributor/'
    | '/consent/sms/details'
    | '/dashboard/contacts/$uuid'
    | '/dashboard/distributors/$uuid'
    | '/dashboard/drip/dashboard'
    | '/dashboard/drip/emails'
    | '/dashboard/lists/$uuid'
    | '/dashboard/places/$uuid'
    | '/dashboard/scorecard/monitor'
    | '/dashboard/scorecard/thresholds'
    | '/dashboard/scorecard/watchlist'
    | '/dashboard/scorecard/create'
    | '/dashboard/voice-sales/agent'
    | '/dashboard/voice-sales/calls'
    | '/dashboard/voice-sales/campaigns'
    | '/dashboard/zip-blasts/$uuid'
    | '/dashboard/zip-blasts/new'
    | '/consent/sms/'
    | '/dashboard/chains/'
    | '/dashboard/contacts/'
    | '/dashboard/distributors/'
    | '/dashboard/lists/'
    | '/dashboard/places/'
    | '/dashboard/scorecard/'
    | '/dashboard/voice-sales/'
    | '/dashboard/zip-blasts/'
    | '/dashboard/chains/searches/$uuid'
    | '/dashboard/drip/campaigns/$uuid'
    | '/dashboard/drip/contacts/$uuid'
    | '/dashboard/scorecard/chains/$uuid'
    | '/dashboard/scorecard/watchlist/$uuid'
    | '/dashboard/voice-sales/calls/$callUuid'
    | '/dashboard/voice-sales/campaigns/$campaignUuid'
    | '/dashboard/voice-sales/campaigns/new'
    | '/drip/contacts/$uuid/opt-out'
    | '/drip/emails/$uuid/report'
    | '/dashboard/chains/$chainUuid/'
    | '/dashboard/drip/campaigns/'
    | '/dashboard/drip/contacts/'
    | '/dashboard/scorecard/chains/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/auth/callback'
    | '/c/adam'
    | '/chain/$slugOrUuid'
    | '/create/$publicCode'
    | '/d/$path'
    | '/dashboard/bulk-jobs'
    | '/h/$slug'
    | '/$uuid'
    | '/create'
    | '/dashboard'
    | '/distributor'
    | '/consent/sms/details'
    | '/dashboard/contacts/$uuid'
    | '/dashboard/distributors/$uuid'
    | '/dashboard/drip/dashboard'
    | '/dashboard/drip/emails'
    | '/dashboard/lists/$uuid'
    | '/dashboard/places/$uuid'
    | '/dashboard/scorecard/monitor'
    | '/dashboard/scorecard/thresholds'
    | '/dashboard/scorecard/watchlist'
    | '/dashboard/scorecard/create'
    | '/dashboard/voice-sales/agent'
    | '/dashboard/voice-sales/calls'
    | '/dashboard/voice-sales/campaigns'
    | '/dashboard/zip-blasts/$uuid'
    | '/dashboard/zip-blasts/new'
    | '/consent/sms'
    | '/dashboard/chains'
    | '/dashboard/contacts'
    | '/dashboard/distributors'
    | '/dashboard/lists'
    | '/dashboard/places'
    | '/dashboard/scorecard'
    | '/dashboard/voice-sales'
    | '/dashboard/zip-blasts'
    | '/dashboard/chains/searches/$uuid'
    | '/dashboard/drip/campaigns/$uuid'
    | '/dashboard/drip/contacts/$uuid'
    | '/dashboard/scorecard/chains/$uuid'
    | '/dashboard/scorecard/watchlist/$uuid'
    | '/dashboard/voice-sales/calls/$callUuid'
    | '/dashboard/voice-sales/campaigns/$campaignUuid'
    | '/dashboard/voice-sales/campaigns/new'
    | '/drip/contacts/$uuid/opt-out'
    | '/drip/emails/$uuid/report'
    | '/dashboard/chains/$chainUuid'
    | '/dashboard/drip/campaigns'
    | '/dashboard/drip/contacts'
    | '/dashboard/scorecard/chains'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/distributor'
    | '/privacy'
    | '/auth/callback'
    | '/c/adam'
    | '/chain/$slugOrUuid'
    | '/create/$publicCode'
    | '/d/$path'
    | '/dashboard/bulk-jobs'
    | '/dashboard/voice-sales'
    | '/h/$slug'
    | '/$uuid/'
    | '/create/'
    | '/dashboard/'
    | '/distributor/'
    | '/consent/sms/details'
    | '/dashboard/contacts_/$uuid'
    | '/dashboard/distributors_/$uuid'
    | '/dashboard/drip/dashboard'
    | '/dashboard/drip/emails'
    | '/dashboard/lists_/$uuid'
    | '/dashboard/places_/$uuid'
    | '/dashboard/scorecard/monitor'
    | '/dashboard/scorecard/thresholds'
    | '/dashboard/scorecard/watchlist'
    | '/dashboard/scorecard_/create'
    | '/dashboard/voice-sales/agent'
    | '/dashboard/voice-sales/calls'
    | '/dashboard/voice-sales/campaigns'
    | '/dashboard/zip-blasts_/$uuid'
    | '/dashboard/zip-blasts_/new'
    | '/consent/sms/'
    | '/dashboard/chains/'
    | '/dashboard/contacts/'
    | '/dashboard/distributors/'
    | '/dashboard/lists/'
    | '/dashboard/places/'
    | '/dashboard/scorecard/'
    | '/dashboard/voice-sales/'
    | '/dashboard/zip-blasts/'
    | '/dashboard/chains_/searches/$uuid'
    | '/dashboard/drip/campaigns_/$uuid'
    | '/dashboard/drip/contacts_/$uuid'
    | '/dashboard/scorecard/chains_/$uuid'
    | '/dashboard/scorecard/watchlist_/$uuid'
    | '/dashboard/voice-sales/calls_/$callUuid'
    | '/dashboard/voice-sales/campaigns_/$campaignUuid'
    | '/dashboard/voice-sales/campaigns_/new'
    | '/drip/contacts/$uuid/opt-out'
    | '/drip/emails/$uuid/report'
    | '/dashboard/chains_/$chainUuid/'
    | '/dashboard/drip/campaigns/'
    | '/dashboard/drip/contacts/'
    | '/dashboard/scorecard/chains/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  DistributorRoute: typeof DistributorRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CAdamRoute: typeof CAdamRoute
  ChainSlugOrUuidRoute: typeof ChainSlugOrUuidRoute
  CreatePublicCodeRoute: typeof CreatePublicCodeRoute
  DPathRoute: typeof DPathRoute
  HSlugRoute: typeof HSlugRoute
  UuidIndexRoute: typeof UuidIndexRoute
  CreateIndexRoute: typeof CreateIndexRoute
  ConsentSmsDetailsRoute: typeof ConsentSmsDetailsRoute
  ConsentSmsIndexRoute: typeof ConsentSmsIndexRoute
  DripContactsUuidOptOutRoute: typeof DripContactsUuidOptOutRoute
  DripEmailsUuidReportRoute: typeof DripEmailsUuidReportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributor': {
      id: '/distributor'
      path: '/distributor'
      fullPath: '/distributor'
      preLoaderRoute: typeof DistributorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributor/': {
      id: '/distributor/'
      path: '/'
      fullPath: '/distributor/'
      preLoaderRoute: typeof DistributorIndexRouteImport
      parentRoute: typeof DistributorRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create/'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$uuid/': {
      id: '/$uuid/'
      path: '/$uuid'
      fullPath: '/$uuid/'
      preLoaderRoute: typeof UuidIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/h/$slug': {
      id: '/h/$slug'
      path: '/h/$slug'
      fullPath: '/h/$slug'
      preLoaderRoute: typeof HSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/voice-sales': {
      id: '/dashboard/voice-sales'
      path: '/voice-sales'
      fullPath: '/dashboard/voice-sales'
      preLoaderRoute: typeof DashboardVoiceSalesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/bulk-jobs': {
      id: '/dashboard/bulk-jobs'
      path: '/bulk-jobs'
      fullPath: '/dashboard/bulk-jobs'
      preLoaderRoute: typeof DashboardBulkJobsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/d/$path': {
      id: '/d/$path'
      path: '/d/$path'
      fullPath: '/d/$path'
      preLoaderRoute: typeof DPathRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/$publicCode': {
      id: '/create/$publicCode'
      path: '/create/$publicCode'
      fullPath: '/create/$publicCode'
      preLoaderRoute: typeof CreatePublicCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chain/$slugOrUuid': {
      id: '/chain/$slugOrUuid'
      path: '/chain/$slugOrUuid'
      fullPath: '/chain/$slugOrUuid'
      preLoaderRoute: typeof ChainSlugOrUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/adam': {
      id: '/c/adam'
      path: '/c/adam'
      fullPath: '/c/adam'
      preLoaderRoute: typeof CAdamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/zip-blasts/': {
      id: '/dashboard/zip-blasts/'
      path: '/zip-blasts'
      fullPath: '/dashboard/zip-blasts/'
      preLoaderRoute: typeof DashboardZipBlastsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/voice-sales/': {
      id: '/dashboard/voice-sales/'
      path: '/'
      fullPath: '/dashboard/voice-sales/'
      preLoaderRoute: typeof DashboardVoiceSalesIndexRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/scorecard/': {
      id: '/dashboard/scorecard/'
      path: '/scorecard'
      fullPath: '/dashboard/scorecard/'
      preLoaderRoute: typeof DashboardScorecardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/places/': {
      id: '/dashboard/places/'
      path: '/places'
      fullPath: '/dashboard/places/'
      preLoaderRoute: typeof DashboardPlacesIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/lists/': {
      id: '/dashboard/lists/'
      path: '/lists'
      fullPath: '/dashboard/lists/'
      preLoaderRoute: typeof DashboardListsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/distributors/': {
      id: '/dashboard/distributors/'
      path: '/distributors'
      fullPath: '/dashboard/distributors/'
      preLoaderRoute: typeof DashboardDistributorsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contacts/': {
      id: '/dashboard/contacts/'
      path: '/contacts'
      fullPath: '/dashboard/contacts/'
      preLoaderRoute: typeof DashboardContactsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/chains/': {
      id: '/dashboard/chains/'
      path: '/chains'
      fullPath: '/dashboard/chains/'
      preLoaderRoute: typeof DashboardChainsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/consent/sms/': {
      id: '/consent/sms/'
      path: '/consent/sms'
      fullPath: '/consent/sms/'
      preLoaderRoute: typeof ConsentSmsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/zip-blasts_/new': {
      id: '/dashboard/zip-blasts_/new'
      path: '/zip-blasts/new'
      fullPath: '/dashboard/zip-blasts/new'
      preLoaderRoute: typeof DashboardZipBlastsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/zip-blasts_/$uuid': {
      id: '/dashboard/zip-blasts_/$uuid'
      path: '/zip-blasts/$uuid'
      fullPath: '/dashboard/zip-blasts/$uuid'
      preLoaderRoute: typeof DashboardZipBlastsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/voice-sales/campaigns': {
      id: '/dashboard/voice-sales/campaigns'
      path: '/campaigns'
      fullPath: '/dashboard/voice-sales/campaigns'
      preLoaderRoute: typeof DashboardVoiceSalesCampaignsRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/voice-sales/calls': {
      id: '/dashboard/voice-sales/calls'
      path: '/calls'
      fullPath: '/dashboard/voice-sales/calls'
      preLoaderRoute: typeof DashboardVoiceSalesCallsRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/voice-sales/agent': {
      id: '/dashboard/voice-sales/agent'
      path: '/agent'
      fullPath: '/dashboard/voice-sales/agent'
      preLoaderRoute: typeof DashboardVoiceSalesAgentRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/scorecard_/create': {
      id: '/dashboard/scorecard_/create'
      path: '/scorecard/create'
      fullPath: '/dashboard/scorecard/create'
      preLoaderRoute: typeof DashboardScorecardCreateRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/scorecard/watchlist': {
      id: '/dashboard/scorecard/watchlist'
      path: '/scorecard/watchlist'
      fullPath: '/dashboard/scorecard/watchlist'
      preLoaderRoute: typeof DashboardScorecardWatchlistRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/scorecard/thresholds': {
      id: '/dashboard/scorecard/thresholds'
      path: '/scorecard/thresholds'
      fullPath: '/dashboard/scorecard/thresholds'
      preLoaderRoute: typeof DashboardScorecardThresholdsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/scorecard/monitor': {
      id: '/dashboard/scorecard/monitor'
      path: '/scorecard/monitor'
      fullPath: '/dashboard/scorecard/monitor'
      preLoaderRoute: typeof DashboardScorecardMonitorRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/places_/$uuid': {
      id: '/dashboard/places_/$uuid'
      path: '/places/$uuid'
      fullPath: '/dashboard/places/$uuid'
      preLoaderRoute: typeof DashboardPlacesUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/lists_/$uuid': {
      id: '/dashboard/lists_/$uuid'
      path: '/lists/$uuid'
      fullPath: '/dashboard/lists/$uuid'
      preLoaderRoute: typeof DashboardListsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/drip/emails': {
      id: '/dashboard/drip/emails'
      path: '/drip/emails'
      fullPath: '/dashboard/drip/emails'
      preLoaderRoute: typeof DashboardDripEmailsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/drip/dashboard': {
      id: '/dashboard/drip/dashboard'
      path: '/drip/dashboard'
      fullPath: '/dashboard/drip/dashboard'
      preLoaderRoute: typeof DashboardDripDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/distributors_/$uuid': {
      id: '/dashboard/distributors_/$uuid'
      path: '/distributors/$uuid'
      fullPath: '/dashboard/distributors/$uuid'
      preLoaderRoute: typeof DashboardDistributorsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/contacts_/$uuid': {
      id: '/dashboard/contacts_/$uuid'
      path: '/contacts/$uuid'
      fullPath: '/dashboard/contacts/$uuid'
      preLoaderRoute: typeof DashboardContactsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/consent/sms/details': {
      id: '/consent/sms/details'
      path: '/consent/sms/details'
      fullPath: '/consent/sms/details'
      preLoaderRoute: typeof ConsentSmsDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/scorecard/chains/': {
      id: '/dashboard/scorecard/chains/'
      path: '/scorecard/chains'
      fullPath: '/dashboard/scorecard/chains/'
      preLoaderRoute: typeof DashboardScorecardChainsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/drip/contacts/': {
      id: '/dashboard/drip/contacts/'
      path: '/drip/contacts'
      fullPath: '/dashboard/drip/contacts/'
      preLoaderRoute: typeof DashboardDripContactsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/drip/campaigns/': {
      id: '/dashboard/drip/campaigns/'
      path: '/drip/campaigns'
      fullPath: '/dashboard/drip/campaigns/'
      preLoaderRoute: typeof DashboardDripCampaignsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/chains_/$chainUuid/': {
      id: '/dashboard/chains_/$chainUuid/'
      path: '/chains/$chainUuid'
      fullPath: '/dashboard/chains/$chainUuid/'
      preLoaderRoute: typeof DashboardChainsChainUuidIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/drip/emails/$uuid/report': {
      id: '/drip/emails/$uuid/report'
      path: '/drip/emails/$uuid/report'
      fullPath: '/drip/emails/$uuid/report'
      preLoaderRoute: typeof DripEmailsUuidReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drip/contacts/$uuid/opt-out': {
      id: '/drip/contacts/$uuid/opt-out'
      path: '/drip/contacts/$uuid/opt-out'
      fullPath: '/drip/contacts/$uuid/opt-out'
      preLoaderRoute: typeof DripContactsUuidOptOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/voice-sales/campaigns_/new': {
      id: '/dashboard/voice-sales/campaigns_/new'
      path: '/campaigns/new'
      fullPath: '/dashboard/voice-sales/campaigns/new'
      preLoaderRoute: typeof DashboardVoiceSalesCampaignsNewRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/voice-sales/campaigns_/$campaignUuid': {
      id: '/dashboard/voice-sales/campaigns_/$campaignUuid'
      path: '/campaigns/$campaignUuid'
      fullPath: '/dashboard/voice-sales/campaigns/$campaignUuid'
      preLoaderRoute: typeof DashboardVoiceSalesCampaignsCampaignUuidRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/voice-sales/calls_/$callUuid': {
      id: '/dashboard/voice-sales/calls_/$callUuid'
      path: '/calls/$callUuid'
      fullPath: '/dashboard/voice-sales/calls/$callUuid'
      preLoaderRoute: typeof DashboardVoiceSalesCallsCallUuidRouteImport
      parentRoute: typeof DashboardVoiceSalesRoute
    }
    '/dashboard/scorecard/watchlist_/$uuid': {
      id: '/dashboard/scorecard/watchlist_/$uuid'
      path: '/scorecard/watchlist/$uuid'
      fullPath: '/dashboard/scorecard/watchlist/$uuid'
      preLoaderRoute: typeof DashboardScorecardWatchlistUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/scorecard/chains_/$uuid': {
      id: '/dashboard/scorecard/chains_/$uuid'
      path: '/scorecard/chains/$uuid'
      fullPath: '/dashboard/scorecard/chains/$uuid'
      preLoaderRoute: typeof DashboardScorecardChainsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/drip/contacts_/$uuid': {
      id: '/dashboard/drip/contacts_/$uuid'
      path: '/drip/contacts/$uuid'
      fullPath: '/dashboard/drip/contacts/$uuid'
      preLoaderRoute: typeof DashboardDripContactsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/drip/campaigns_/$uuid': {
      id: '/dashboard/drip/campaigns_/$uuid'
      path: '/drip/campaigns/$uuid'
      fullPath: '/dashboard/drip/campaigns/$uuid'
      preLoaderRoute: typeof DashboardDripCampaignsUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/chains_/searches/$uuid': {
      id: '/dashboard/chains_/searches/$uuid'
      path: '/chains/searches/$uuid'
      fullPath: '/dashboard/chains/searches/$uuid'
      preLoaderRoute: typeof DashboardChainsSearchesUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardVoiceSalesRouteChildren {
  DashboardVoiceSalesAgentRoute: typeof DashboardVoiceSalesAgentRoute
  DashboardVoiceSalesCallsRoute: typeof DashboardVoiceSalesCallsRoute
  DashboardVoiceSalesCampaignsRoute: typeof DashboardVoiceSalesCampaignsRoute
  DashboardVoiceSalesIndexRoute: typeof DashboardVoiceSalesIndexRoute
  DashboardVoiceSalesCallsCallUuidRoute: typeof DashboardVoiceSalesCallsCallUuidRoute
  DashboardVoiceSalesCampaignsCampaignUuidRoute: typeof DashboardVoiceSalesCampaignsCampaignUuidRoute
  DashboardVoiceSalesCampaignsNewRoute: typeof DashboardVoiceSalesCampaignsNewRoute
}

const DashboardVoiceSalesRouteChildren: DashboardVoiceSalesRouteChildren = {
  DashboardVoiceSalesAgentRoute: DashboardVoiceSalesAgentRoute,
  DashboardVoiceSalesCallsRoute: DashboardVoiceSalesCallsRoute,
  DashboardVoiceSalesCampaignsRoute: DashboardVoiceSalesCampaignsRoute,
  DashboardVoiceSalesIndexRoute: DashboardVoiceSalesIndexRoute,
  DashboardVoiceSalesCallsCallUuidRoute: DashboardVoiceSalesCallsCallUuidRoute,
  DashboardVoiceSalesCampaignsCampaignUuidRoute:
    DashboardVoiceSalesCampaignsCampaignUuidRoute,
  DashboardVoiceSalesCampaignsNewRoute: DashboardVoiceSalesCampaignsNewRoute,
}

const DashboardVoiceSalesRouteWithChildren =
  DashboardVoiceSalesRoute._addFileChildren(DashboardVoiceSalesRouteChildren)

interface DashboardRouteChildren {
  DashboardBulkJobsRoute: typeof DashboardBulkJobsRoute
  DashboardVoiceSalesRoute: typeof DashboardVoiceSalesRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardContactsUuidRoute: typeof DashboardContactsUuidRoute
  DashboardDistributorsUuidRoute: typeof DashboardDistributorsUuidRoute
  DashboardDripDashboardRoute: typeof DashboardDripDashboardRoute
  DashboardDripEmailsRoute: typeof DashboardDripEmailsRoute
  DashboardListsUuidRoute: typeof DashboardListsUuidRoute
  DashboardPlacesUuidRoute: typeof DashboardPlacesUuidRoute
  DashboardScorecardMonitorRoute: typeof DashboardScorecardMonitorRoute
  DashboardScorecardThresholdsRoute: typeof DashboardScorecardThresholdsRoute
  DashboardScorecardWatchlistRoute: typeof DashboardScorecardWatchlistRoute
  DashboardScorecardCreateRoute: typeof DashboardScorecardCreateRoute
  DashboardZipBlastsUuidRoute: typeof DashboardZipBlastsUuidRoute
  DashboardZipBlastsNewRoute: typeof DashboardZipBlastsNewRoute
  DashboardChainsIndexRoute: typeof DashboardChainsIndexRoute
  DashboardContactsIndexRoute: typeof DashboardContactsIndexRoute
  DashboardDistributorsIndexRoute: typeof DashboardDistributorsIndexRoute
  DashboardListsIndexRoute: typeof DashboardListsIndexRoute
  DashboardPlacesIndexRoute: typeof DashboardPlacesIndexRoute
  DashboardScorecardIndexRoute: typeof DashboardScorecardIndexRoute
  DashboardZipBlastsIndexRoute: typeof DashboardZipBlastsIndexRoute
  DashboardChainsSearchesUuidRoute: typeof DashboardChainsSearchesUuidRoute
  DashboardDripCampaignsUuidRoute: typeof DashboardDripCampaignsUuidRoute
  DashboardDripContactsUuidRoute: typeof DashboardDripContactsUuidRoute
  DashboardScorecardChainsUuidRoute: typeof DashboardScorecardChainsUuidRoute
  DashboardScorecardWatchlistUuidRoute: typeof DashboardScorecardWatchlistUuidRoute
  DashboardChainsChainUuidIndexRoute: typeof DashboardChainsChainUuidIndexRoute
  DashboardDripCampaignsIndexRoute: typeof DashboardDripCampaignsIndexRoute
  DashboardDripContactsIndexRoute: typeof DashboardDripContactsIndexRoute
  DashboardScorecardChainsIndexRoute: typeof DashboardScorecardChainsIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardBulkJobsRoute: DashboardBulkJobsRoute,
  DashboardVoiceSalesRoute: DashboardVoiceSalesRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardContactsUuidRoute: DashboardContactsUuidRoute,
  DashboardDistributorsUuidRoute: DashboardDistributorsUuidRoute,
  DashboardDripDashboardRoute: DashboardDripDashboardRoute,
  DashboardDripEmailsRoute: DashboardDripEmailsRoute,
  DashboardListsUuidRoute: DashboardListsUuidRoute,
  DashboardPlacesUuidRoute: DashboardPlacesUuidRoute,
  DashboardScorecardMonitorRoute: DashboardScorecardMonitorRoute,
  DashboardScorecardThresholdsRoute: DashboardScorecardThresholdsRoute,
  DashboardScorecardWatchlistRoute: DashboardScorecardWatchlistRoute,
  DashboardScorecardCreateRoute: DashboardScorecardCreateRoute,
  DashboardZipBlastsUuidRoute: DashboardZipBlastsUuidRoute,
  DashboardZipBlastsNewRoute: DashboardZipBlastsNewRoute,
  DashboardChainsIndexRoute: DashboardChainsIndexRoute,
  DashboardContactsIndexRoute: DashboardContactsIndexRoute,
  DashboardDistributorsIndexRoute: DashboardDistributorsIndexRoute,
  DashboardListsIndexRoute: DashboardListsIndexRoute,
  DashboardPlacesIndexRoute: DashboardPlacesIndexRoute,
  DashboardScorecardIndexRoute: DashboardScorecardIndexRoute,
  DashboardZipBlastsIndexRoute: DashboardZipBlastsIndexRoute,
  DashboardChainsSearchesUuidRoute: DashboardChainsSearchesUuidRoute,
  DashboardDripCampaignsUuidRoute: DashboardDripCampaignsUuidRoute,
  DashboardDripContactsUuidRoute: DashboardDripContactsUuidRoute,
  DashboardScorecardChainsUuidRoute: DashboardScorecardChainsUuidRoute,
  DashboardScorecardWatchlistUuidRoute: DashboardScorecardWatchlistUuidRoute,
  DashboardChainsChainUuidIndexRoute: DashboardChainsChainUuidIndexRoute,
  DashboardDripCampaignsIndexRoute: DashboardDripCampaignsIndexRoute,
  DashboardDripContactsIndexRoute: DashboardDripContactsIndexRoute,
  DashboardScorecardChainsIndexRoute: DashboardScorecardChainsIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface DistributorRouteChildren {
  DistributorIndexRoute: typeof DistributorIndexRoute
}

const DistributorRouteChildren: DistributorRouteChildren = {
  DistributorIndexRoute: DistributorIndexRoute,
}

const DistributorRouteWithChildren = DistributorRoute._addFileChildren(
  DistributorRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  DistributorRoute: DistributorRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CAdamRoute: CAdamRoute,
  ChainSlugOrUuidRoute: ChainSlugOrUuidRoute,
  CreatePublicCodeRoute: CreatePublicCodeRoute,
  DPathRoute: DPathRoute,
  HSlugRoute: HSlugRoute,
  UuidIndexRoute: UuidIndexRoute,
  CreateIndexRoute: CreateIndexRoute,
  ConsentSmsDetailsRoute: ConsentSmsDetailsRoute,
  ConsentSmsIndexRoute: ConsentSmsIndexRoute,
  DripContactsUuidOptOutRoute: DripContactsUuidOptOutRoute,
  DripEmailsUuidReportRoute: DripEmailsUuidReportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
